import Vue from "vue"
import Vuex from "vuex"
import countries from '../modules/countries/_store'
import invoices from '../modules/invoices/_store'
import magazine from '../modules/magazine/_store'
import router from '../router'
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        siderLeftVisibility: false,
        siderRightVisibility: false,
        headerVisibility: false,
        snackbarVisibility: false,
        permissions: null,
        profile: "",


        pageTitle: 'Loading...',
        token: localStorage.getItem('access_token') || null,
    },

    modules: {
        countries: countries,
        invoices: invoices,
        magazine: magazine
    },

    getters: {
        loggedIn(state) {
            return state.token != null
        },

        nameFirstChar(state) {
            return state.profile.charAt(0)
        }
    },

    mutations: {
        toggleSiderLeftVisibility(state, setTo) {
            state.siderLeftVisibility = (typeof setTo === "boolean") ? setTo : !state.siderLeftVisibility;
        },

        toggleSiderRightVisibility(state, setTo) {
            state.siderRightVisibility = (typeof setTo === "boolean") ? setTo : !state.siderRightVisibility
        },

        toggleHeaderVisibility(state, setTo) {
            state.headerVisibility = (typeof setTo === "boolean") ? setTo : !state.headerVisibility
        },

        activateSnackbar(state) {
            state.snackbarVisibility = true
        },

        deactivateSnackbar(state) {
            state.snackbarVisibility = false
        },

        updatePageTitle(state, title) {
            state.pageTitle = title
        },

        retrieveToken(state, token) {
            state.token = token
        },

        updateProfile(state, data) {
            state.permissions = data.permissions
            state.profile = data.profile
        },

        destroyToken(state) {
            localStorage.removeItem('access_token')
            state.token = null
        },
    },

    actions: {
        retrieveToken(context, credentials) {

            return new Promise((resolve, reject) => {

                _axios.post('api/login',
                    {
                        username: credentials.username,
                        password: credentials.password
                    })
                    .then((response) => {
                            const token = response.data.access_token
                            //const permissions = response.data.permissions
                            localStorage.setItem('access_token', token)

                            context.commit('toggleHeaderVisibility', true);
                            context.commit('toggleSiderLeftVisibility', true);
                            context.commit('retrieveToken', token)

                            axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

                            //context.commit('updateProfile', response.data)
                            //_axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

                            resolve(response);
                        }
                    ).then(() => {
                            context.dispatch('loadUserData')
                })
                    .catch((error) => {
                            // Access denied
                            reject(error)
                        }
                    )
            })
        },

        loadUserData(context) {

            axios.get('api/user/profile')
                .then(
                    (response) => {
                        context.commit('updateProfile', response.data)
                        context.commit('countries/updateAvCountries', response.data.avCountries)
                        _axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
                        //resolve(response);
                    }
                )
                .catch(
                    (error) => {
                        // Access denied
                        //reject(error)
                        console.log(error)
                    }
                )
        },

        logoutUser(context) {
            if (context.getters.loggedIn) {

                context.commit('destroyToken')

                return new Promise((resolve, reject) => {

                    _axios.post('api/logout')
                        .then(
                            (response) => {
                                context.dispatch('goToLoginPage')
                                resolve(response)
                            }
                        )
                        .catch(
                            (error) => {
                                context.dispatch('goToLoginPage')
                                reject(error)
                            }
                        )
                })
            }
        },

        goToLoginPage(context) {
            context.commit('toggleHeaderVisibility', false);
            context.commit('toggleSiderLeftVisibility', false);
            context.commit('toggleSiderRightVisibility', false);
            router.push({name: 'Login'})
        }
    }
});
